(function ($, document, window, undefined) {

    var Global = function() {

        var $videoPlayer

        var videoPlayer = function() {

            //var $playButton = $(document).find("[data-js=play-video]")

            var playVideo = function(e) {

                console.dir( $(e.target ));

                if( $videoPlayer.hasClass("playing-video") ) return

                $videoPlayer.addClass("playing-video")

                var video = $videoPlayer.find("video")[0]
                video.play();

                setTimeout(function(){
                    video.controls = true
                }, 500)

                video.onended = function() {
                    video.controls = false
                    video.load()
                    $videoPlayer.removeClass("playing-video")
                };
            }

            $(document).on("click", "[data-js=play-video]", playVideo);
        }

        var init = function() {

            $videoPlayer = $(document).find("[data-js='video-player']")
            if( $videoPlayer.length >= 1) videoPlayer()

            /**
             * COVID-19 Message
             **/
             document.querySelector('.alert-message-dismiss').addEventListener(
             'click', function (e) {
                 var element = document.querySelector('.covid .covid-wrapper');
                 element.parentNode.removeChild(element);
             });



        }

        return { init }


    }()

    if (!window.Frontier) window.Frontier = {};
        window.Frontier.Global = Global;

}(jQuery, document, window));
